import React from "react";

// Single-choice option group used by the list-screen filter dropdowns.
//
// variant="chip" (default): options are pill chips - the selected one is blue
// with a tick, and clicking it again clears the filter (handleChange gets
// value ""), so a filter can be undone without a separate reset.
// variant="radio": the classic radio list, for non-dropdown uses (graph
// period toggle, Payment In/Out "Select One") that should keep their look.
//
// handleChange always receives an event-like { target: { name, value } }, so
// every existing `e.target.value` handler works unchanged.
const FilterRadioButtons = ({
  options,
  handleChange = () => {},
  value,
  label,
  name = "",
  variant = "chip",
  valueclass = "flex gap-2 flex-col ml-1",
  className = "flex gap-2 flex-col mt-3 ml-1",
  subClass = "flex items-center",
}) => {
  if (variant === "radio") {
    return (
      <div className={className}>
        <label className=" font-[var(--popover-heading-font-weight)] text-[length:--popover-font-size] text-[var(--popover-heading-fg-color)]  ">
          {label}
        </label>
        <div className={valueclass}>
          {options?.map((option) => (
            <div key={option?.value} className={subClass}>
              <input
                type="radio"
                id={option.value + name}
                name={name}
                value={option.value}
                checked={value === option?.value}
                onChange={handleChange}
              />
              <label
                htmlFor={option.value + name}
                className="ml-2 font-[var(--popover-font-weight)] cursor-pointer  text-[length:--popover-font-size] text-[var(--popover-fg-color)] whitespace-nowrap"
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const select = (optionValue) =>
    handleChange({
      target: { name, value: value === optionValue ? "" : optionValue },
    });

  return (
    <div className="flex flex-col gap-2 px-3 py-2.5">
      {label && (
        <span className="text-[11px] fw_600 uppercase tracking-wider text-[var(--description-color)]">
          {label}
        </span>
      )}
      <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
        {options?.map((option) => {
          const selected = value === option?.value;
          return (
            <button
              key={option?.value}
              type="button"
              role="radio"
              aria-checked={selected}
              title={selected ? "Click again to clear" : ""}
              onClick={() => select(option.value)}
              className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full border text-[length:--popover-font-size] whitespace-nowrap transition-colors ${
                selected
                  ? "border-[var(--primary)] bg-[var(--row-selection-color)] text-[var(--primary)] fw_600"
                  : "border-[var(--popover-border-color)] bg-white text-[var(--popover-fg-color)] hover:border-[var(--primary)] hover:text-[var(--primary)]"
              }`}
            >
              {selected && (
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              )}
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FilterRadioButtons;
